import { AssetsProvider, useQuery, useRouter } from '@obvio/app'
import { Loading } from '@obvio/ui'

import { GridInfo3 } from '../GridInfo3'
import { QUERIES } from '@/constants/queries'

import type { ReactElement } from 'react'

export function EventsGrid(): ReactElement | null {
  const { setParam } = useRouter()
  const { data, loading } = useQuery('getEvents', {
    select: QUERIES['events-grid'].getEvents,
    args: {
      unique: true,
    },
  })

  return loading ? (
    <Loading />
  ) : (
    data && (
      <AssetsProvider path="/event">
        <GridInfo3
          elements={data.map((d) => ({
            ...d,
            image: d.images[0],
            handleClick: () => setParam('id', d.slug),
            hrefTitle: 'ZAPISZ SIĘ',
          }))}
        />
      </AssetsProvider>
    )
  )
}
